import Component,{register} from '@services/component'
import Page from '@services/page'
import {toggleClass,find,createElement} from '@services/dom'
import anime from 'animejs'
import defaultTextureSource from '@assets/images/page-menu-aside.jpg'
import logo from '@assets/images/logo-big-negative.svg'
import {switcher as createSwitcher} from 'displacer'
import displacementTextureSource from 'displacer/src/docs/assets/7.jpg'

export const defaults = {
    defaultTextureSource,
    displacementTextureSource,
    logo
};

export default register(
    class Menu extends Component {
        static selector = '.page-navigation .menu-toggle'

        state = {
            open:false
        }

        create(){

            this.container = createElement(`<div class="page-main-menu is-reversed" />`);
            document.body.appendChild(this.container);

            this.image = createElement(`<a href="/" class="aside-image has-tint"><canvas /><div /></a>`);
            this.container.appendChild(this.image);

            this.logo = createElement(`<img class="aside-logo" src="${defaults.logo}" />`);
            this.image.appendChild(this.logo);

            this.toggle = this.el.cloneNode(true);
            document.body.appendChild(this.toggle);
            this.toggle.querySelector('.label').textContent = 'Close';

            this.menuCol = createElement(`<div class="menu-col" />`);
            this.container.appendChild(this.menuCol);

            let [main] = find('.page-navigation > nav > .main-menu');

            let [secondary] = find('.page-navigation > nav > .secondary-menu');

            let [meta] = find('.page-navigation > nav > .meta-menu');

            main && this.menuCol.appendChild(main = main.cloneNode(true));
            secondary && this.menuCol.appendChild(secondary = secondary.cloneNode(true));
            meta && this.container.appendChild(meta = meta.cloneNode(true));

            this.anchors = [];
            main && (this.anchors = [...this.anchors, ...main.children]);
            secondary && (this.anchors = [...this.anchors, ...secondary.children]);
            meta && (this.anchors = [...this.anchors, ...meta.children]);

            this.container.style.visibility='hidden';
            this.on(this.toggle,'click',this.handleToggle);
            this.on(this.el,'click',this.handleToggle);

            find('a',this.container).filter(link => link.href.startsWith('/') || link.href.startsWith(window.location.origin)).forEach(link => {
                this.on(link,'click',this.handleLinkClick.bind(this,link));
            });

            this.initSwitcher(this.image.querySelector('canvas'),find('[data-src-hovered]',this.container));
        }

        destroy(){
            super.destroy();
            this.container.parentElement.removeChild(this.container);
            this.toggle.parentElement.removeChild(this.toggle);
        }

        setToggleState(open){
            Array.from(document.querySelectorAll('.toggle-state-icon')).forEach(element=>{
                toggleClass(element,'toggled',open);
            });
        }

        handleLinkClick = (link,e) => {
            e.stopPropagation();
            e.preventDefault();

            if(this.animating) return;

            this.animating = true;

            this.setToggleState(false);

            this.animateOut(()=>{
                this.animating = false;
                this.setState({open:false});

                if(link.href && Page.instance && Page.instance.swup) {
                    setTimeout(()=>{
                        this.container.style.visibility='hidden';
                    },500);
                    Page.instance && Page.instance.swup.loadPage({
                        url: link.href
                    });
                }

            },false);
        }

        handleToggle = e => {
            if(this.animating) return;
            this.animating = true;
            if(this.state.open) {
                this.setToggleState(false);
                this.animateOut(()=>{
                    this.animating = false;
                    this.setState({open:false});
                    this.container.style.visibility='hidden';
                });
            }else{
                this.container.style.visibility='visible';
                this.animateIn(()=>{
                    this.animating = false;
                    this.setState({open:true});
                    this.setToggleState(true);
                });
            }
        }

        render(){
            const {open} = this.state;

            toggleClass(this.container,'is-open',open);
        }

        animateIn(complete){
            const tl = anime.timeline({
                complete
            });

            tl.add({
                targets:this.container,
                //opacity:[0,1],
                duration:500,
                translateX:["100%","0%"],
                easing: 'easeInOutExpo'
            });

            anime({
                targets:this.image.querySelector('div'),
                //opacity:[1,0],
                translateX:["0%","-100%"],
                duration:500,
                delay:650,
                easing: 'easeInOutExpo'
            });

            anime({
                targets:this.logo,
                opacity:[0,1],
                translateX:["25%","0%"],
                duration:500,
                delay:1000,
                easing: 'easeOutExpo'
            });


            this.toggle.style.visibility = 'visible';
            anime({
                targets:this.toggle,
                opacity:1,
                duration:200,
                delay:650,
                easing: 'easeInOutQuart'
            });

            tl.add({
                targets:this.anchors,
                delay:(el,i)=>150 + 75 * i,
                duration:450,
                translateX:["2rem","0rem"],
                easing:'easeInOutQuint',
                opacity:[0,1]
            });
        }

        animateOut(complete,fade=true){

            anime({
                targets:this.anchors,
                delay:(el,i)=>250 + 25 * i,
                duration:300,
                translateX:["0rem","-2rem"],
                easing:'easeInOutQuint',
                opacity:[1,0]
            });

            if(fade) {
                anime({
                    targets:this.container,
                    opacity:[1,0],
                    //translateY:["0%","100%"],
                    duration:300,
                    delay:500,
                    easing: 'easeInSine',
                    complete:()=>{
                        complete&&complete();
                        this.container.style.opacity = 1;
                    }
                });
            }else{
                setTimeout(()=>{
                    complete&&complete();
                    this.container.style.opacity = 1;
                },500);
            }

            anime({
                targets:this.image.querySelector('div'),
                //opacity:[1,0],
                translateX:["100%","0%"],
                duration:500,
                delay:0,
                easing: 'easeInOutExpo'
            });

            anime({
                targets:this.logo,
                opacity:[1,0],
                translateX:["0%","-25%"],
                duration:500,
                delay:0,
                easing: 'easeInExpo'
            });

            anime({
                targets:this.toggle,
                opacity:0,
                duration:200,
                delay:300,
                easing: 'easeInOutQuart',
                complete:()=>{
                    this.toggle.style.visibility = 'hidden';
                }
            });
        }

        initSwitcher(canvas,menuItems) {

            const switcher = createSwitcher({
                canvas,
                defaultTextureSource: defaults.defaultTextureSource,
                switchTextureSource:menuItems.map(({dataset:{srcHovered}}) => srcHovered),
                displacementTextureSource: defaults.displacementTextureSource,
                displacement:{
                    intensity:.1,
                }
            });

            menuItems.forEach((menuItem,index) => {
                menuItem.addEventListener('mouseover',()=>{
                    switcher.smoothness = 10;
                    switcher.displacement = .5;
                    switcher.show(index);
                });
            });

            this.container.addEventListener('mouseout',e=>{
                if(e.relatedTarget && ["A","LI"].includes(e.relatedTarget.tagName)) return;
                switcher.smoothness = 25;
                switcher.displacement = .1;
                switcher.hide();
            });
        }
    }
);